<template>
  <ul class="list-none p-0 m-0">
    <li
      v-for="article in articles"
      :key="article.id"
      class="py-4 border-b border-brand last:border-b-0"
    >
      <news-details-recent-item :article="article" />
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { StrapiArticle } from '#variant/apollo/types/types';

const props = withDefaults(
  defineProps<{
    articles: Array<StrapiArticle>;
  }>(),
  {
    articles: () => [],
  },
);
</script>
